<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>增值税及附加税费申报表附列资料(四)<br />（税额抵减情况表）</dt>

      <dd>
        <div>纳税人名称（公章）：{{ staticConfig.companyName }}<br />（一般纳税人）</div>

        <div>税款所属期：{{ staticConfig.taxStartTime }} ~ {{ staticConfig.taxEndTime }}</div>

        <div>单位：元至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table class="table1">
        <thead>
          <tr>
            <td colspan="7" style="text-align: center">一、税额抵减情况</td>
          </tr>
          <tr>
            <td rowspan="2" style="width: 50px">序号</td>
            <td rowspan="2" style="width: 140px">抵减项目</td>
            <td class="td_height" style="width: 162px">期初余额</td>
            <td style="width: 162px">本期发生额</td>
            <td style="width: 162px">本期应抵减税额</td>
            <td style="width: 162px">本期实际抵减税额</td>
            <td style="width: 162px">期末余额</td>
          </tr>
          <tr>
            <td class="td_align">1</td>
            <td class="td_align">2</td>
            <td class="td_align">3=1+2</td>
            <td class="td_align">4≤3</td>
            <td class="td_align">5=3-4</td>
          </tr>
        </thead>
        <tbody class="read-mode">
          <tr>
            <td class="td_height td_align">1</td>
            <td class="td_align">增值税税控系统专用设备费及技术维护费</td>
            <td>
              <el-input-number v-model.trim="data.v1x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v1x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v1x3.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v1x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v1x5.value) }}</td>
          </tr>
          <tr>
            <td class="td_height td_align">2</td>
            <td class="td_height td_align">分支机构预征缴纳税款</td>
            <td>
              <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v2x3.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v2x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v2x5.value) }}</td>
          </tr>
          <tr>
            <td class="td_height td_align">3</td>
            <td class="td_height td_align">建筑服务预征缴纳税款</td>
            <td>
              <el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v3x3.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v3x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v3x5.value) }}</td>
          </tr>
          <tr>
            <td class="td_height td_align">4</td>
            <td class="td_height td_align">销售不动产预征缴纳税款</td>
            <td>
              <el-input-number v-model.trim="data.v4x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v4x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v4x3.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v4x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v4x5.value) }}</td>
          </tr>
          <tr>
            <td class="td_height td_align">5</td>
            <td class="td_height td_align">出租不动产预征缴纳税款</td>
            <td>
              <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v5x3.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v5x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v5x5.value) }}</td>
          </tr>
        </tbody>
      </table>
      <table class="table2">
        <thead>
          <tr>
            <td colspan="8" style="text-align: center; border-top: 0px">二、加计抵减情况</td>
          </tr>
          <tr>
            <td rowspan="2" style="width: 50px">序号</td>
            <td rowspan="2" style="width: 140px">加计抵减项目</td>
            <td class="td_height" style="width: 135px">期初余额</td>
            <td style="width: 135px">本期发生额</td>
            <td style="width: 135px">本期调减额</td>
            <td style="width: 135px">本期可抵减额</td>
            <td style="width: 135px">本期实际抵减额</td>
            <td style="width: 135px">期末余额</td>
          </tr>
          <tr>
            <td class="td_align">1</td>
            <td class="td_align">2</td>
            <td class="td_align">3</td>
            <td class="td_align">4=1+2-3</td>
            <td class="td_align">5</td>
            <td class="td_align">6=4-5</td>
          </tr>
        </thead>
        <tbody class="read-mode">
          <tr>
            <td class="td_height td_align">6</td>
            <td class="td_align">一般项目加计抵减额计算</td>
            <td>
              <el-input-number v-model.trim="data.v6x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v6x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v6x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v6x4.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v6x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v6x6.value) }}</td>
          </tr>
          <tr>
            <td class="td_height td_align">7</td>
            <td class="td_align">即征即退项目加计抵减额计算</td>
            <td>
              <el-input-number v-model.trim="data.v7x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v7x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v7x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v7x4.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v7x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v7x6.value) }}</td>
          </tr>
          <tr class="tfooter">
            <td class="td_height td_align">8</td>
            <td class="td_align">合计</td>
            <td>{{ parseFloatNum(data.v8x1.value) }}</td>
            <td>{{ parseFloatNum(data.v8x2.value) }}</td>
            <td>{{ parseFloatNum(data.v8x3.value) }}</td>
            <td>{{ parseFloatNum(data.v8x4.value) }}</td>
            <td>{{ parseFloatNum(data.v8x5.value) }}</td>
            <td>{{ parseFloatNum(data.v8x6.value) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="padding: 5px 0">
      <span style="font-size: 20px; color: red; margin-right: 5px; font-family: monospace">★</span>
      <span>温馨提示：销售额不包括销项税额（或应纳税额），纳税人采用销售额和销项税额合并定价方法的，按照下列公式计算销售额：销售额＝含税销售额÷（1+税率或征收率）</span>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

function watchStart() {
  watch(
    data,
    (newVal, oldVal) => {
      try {
        // 1到5行
        for (let row = 1; row <= 5; row++) {
          // 3=1+2
          data.value[`v${row}x3`].value = new Big(data.value[`v${row}x1`].value).plus(data.value[`v${row}x2`].value).round(2).toNumber();
          // 5=3-4
          data.value[`v${row}x5`].value = new Big(data.value[`v${row}x3`].value).minus(data.value[`v${row}x4`].value).round(2).toNumber();
        }
        // 6到7行
        for (let row = 6; row <= 7; row++) {
          // 4=1+2-3
          data.value[`v${row}x4`].value = new Big(data.value[`v${row}x1`].value).plus(data.value[`v${row}x2`].value).minus(data.value[`v${row}x3`].value).round(2).toNumber();
          // 6=4-5
          data.value[`v${row}x6`].value = new Big(data.value[`v${row}x4`].value).minus(data.value[`v${row}x5`].value).round(2).toNumber();
        }
        // 8行 1到6列合计
        for (let column = 1; column <= 6; column++) {
          // 8=6+7
          data.value[`v8x${column}`].value = new Big(data.value[`v6x${column}`].value).plus(data.value[`v7x${column}`].value).round(2).toNumber();
        }
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss"></style>

<script>
const tableHtml = `
<table class="table1">
  <thead>
    <tr>
      <td colspan="7" style="text-align: center">一、税额抵减情况</td>
    </tr>
    <tr>
      <td rowspan="2" style="width: 50px"><div class="td_height td_align">序号</div></td>
      <td rowspan="2" style="width: 100px"><div class="td_height td_align">抵减项目</div></td>
      <td class="td_height" style="width: 140px"><div class="td_height td_align">期初余额</div></td>
      <td style="width: 140px"><div class="td_height td_align">本期发生额</div></td>
      <td style="width: 140px"><div class="td_height td_align">本期应抵减税额</div></td>
      <td style="width: 140px"><div class="td_height td_align">本期实际抵减税额</div></td>
      <td style="width: 190px"><div class="td_height td_align">期末余额</div></td>
    </tr>
    <tr>
      <td class="td_align">1</td>
      <td class="td_align">2</td>
      <td class="td_align">3=1+2</td>
      <td class="td_align">4≤3</td>
      <td class="td_align">5=3-4</td>
    </tr>
  </thead>
  <tbody class="read-mode">
    <tr>
      <td class="td_height td_align">1</td>
      <td class="td_align">增值税税控系统专用设备费及技术维护费</td>
      <td>
        <div validate="data_1_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_1_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td class="td_height td_align">2</td>
      <td class="td_height td_align">分支机构预征缴纳税款</td>
      <td>
        <div validate="data_2_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_2_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td class="td_height td_align">3</td>
      <td class="td_height td_align">建筑服务预征缴纳税款</td>
      <td>
        <div validate="data_3_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_3_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td class="td_height td_align">4</td>
      <td class="td_height td_align">销售不动产预征缴纳税款</td>
      <td>
        <div validate="data_4_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_4_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_4_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td class="td_height td_align">5</td>
      <td class="td_height td_align">出租不动产预征缴纳税款</td>
      <td>
        <div validate="data_5_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_5_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_5_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
  </tbody>
</table>
<table class="table2">
  <thead>
    <tr>
      <td colspan="8" style="text-align: center; border-top: 0px">二、加计抵减情况</td>
    </tr>
    <tr>
      <td rowspan="2" style="width: 50px"><div class="td_height td_align">序号</div></td>
      <td rowspan="2" style="width: 100px"><div class="td_height td_align">加计抵减项目</div></td>
      <td class="td_height" style="width: 140px"><div class="td_height td_align">期初余额</div></td>
      <td style="width: 140px"><div class="td_height td_align">本期发生额</div></td>
      <td style="width: 140px"><div class="td_height td_align">本期调减额</div></td>
      <td style="width: 140px"><div class="td_height td_align">本期可抵减额</div></td>
      <td style="width: 95px"><div class="td_height td_align">本期实际抵减额</div></td>
      <td style="width: 95px"><div class="td_height td_align">期末余额</div></td>
    </tr>
    <tr>
      <td class="td_align">1</td>
      <td class="td_align">2</td>
      <td class="td_align">3</td>
      <td class="td_align">4=1+2-3</td>
      <td class="td_align">5</td>
      <td class="td_align">6=4-5</td>
    </tr>
  </thead>
  <tbody class="read-mode">
    <tr>
      <td class="td_height td_align">6</td>
      <td class="td_align">一般项目加计抵减额计算</td>
      <td>
        <div validate="data_6_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_6_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_6_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_6_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td class="td_height td_align">7</td>
      <td class="td_align">即征即退项目加计抵减额计算</td>
      <td>
        <div validate="data_7_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_7_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_7_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_7_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr class="tfooter">
      <td class="td_height td_align">8</td>
      <td class="td_align">合计</td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text" autocomplete="off" \/>/g, '<el-input-number v-model.trim="defaultValueNum" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValueNum = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
